import { StorePart } from './components/QuantityColumn'
import AllocatedPopover from './components/AllocatedPopover'

export function render( storePart: StorePart ) {
	const { openReservations } = storePart
	return (
		<AllocatedPopover
			reservations={openReservations}
		/>
	)
}

export default {
	name: 'Allocated',
	render,
}
